<template>
  <div>
    <div class="row">
      <div class="col-xs-12" v-for="filter in definition.filters" :key="filter.id">
        <div class="form-group" v-if="filter.type == 'dynamiclist' || filter.type == 'staticlist'">
          <label for>{{filter.label}}</label>
          <select v-model="panel.filters[filter.id]">
            <option :value="undefined">-- Select --</option>
            <option v-for="(option, index) in filter.options" :key="index" :value="option.value">{{option.label}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../../utils/axios";
export default {
  props: ["panel", "definition"],
  created() {
    if (this.definition.filters && this.definition.filters.length) {
      if (!this.panel.filters) this.panel.filters = {};
      this.definition.filters.forEach((filter, index) => {
        if (filter.type === "dynamiclist") {
          axios.get("filters/" + filter.id + "/options").then(response => {
            filter.options = response.data.result.value || response.data.result.data || response.data.result;
            this.$set(this.definition.filters, index, filter);
          });
        } else if (filter.type === "staticlist") {
          filter.options = filter.staticOptions;
        }
      });
    }
  }
};
</script>

<style>
</style>
